import { useDefaultTableStyling as sytlingOptions } from "./globalStyle"
import { Strings } from '../assets/res/en'

export default function userDataColumn() {
    const columns = [
        { title: Strings.COLUMN_USER_NAME, field: 'name' },
        {
            title: Strings.COLUMN_GROUP, field: 'groupDescription',
            render: (rowdata) => rowdata.idGroup === 0 ? "No Group" : rowdata.groupDescription,
        },
        {
            title: Strings.COLUMN_LOCATION, field: 'merchantDescription',
            render: (rowdata) => rowdata.idMerchant === 0 ? "No Location" : rowdata.merchantDescription
        },
        { title: Strings.COLUMN_USER_PROFILE, field: 'profile' }
    ]
    return { columns, sytlingOptions }
}